import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import * as actionTypes from "../../redux/actionTypes";
import "./previewCard.css";
import financialAsset from "../../assets/financialAsset.svg";
import arrow from "../../assets/arrowGreen.svg";
import commoncss from "../../myfin_v2/css/common.module.css"
import fscss from "../../myfin_v2/css/fs.module.css"


const buttonArrow = {
  backgroundColor: "#D1E0E0",
  width: "30px",
  height: "30px",
  borderRadius: "6px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "auto",
  // position:'absolute',
  // bottom:'10%',
  // right:'10%'
};

const Header = {
  marginTop: "10px",
  fontSize: "20px",
  fontWeight: "700",
  marginBottom: "2rem",
};

const amount = {
  display: "flex",
  alignItems: "center",
  height: "1rem",
  margin: "1rem 0",
};

const paraAmount = {
  color: "#4F4F4F",
  fontSize: "16px",
  fontWeight: "bold",
};

const actualAmount = {
  color: "#4F4F4F",
  fontSize: "14px",
  fontWeight: "normal",
  display: "flex",

  // marginTop:'1rem'
};

const block = {
  display: "flex",
  flexDirection: "column",
};

const PreviewCard = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  let data = props.data;
  let dataInd = data.length - 1
  let py = 0;
  let cy = 0;
  cy = data[dataInd]?.cy;
  py = data[dataInd]?.py;

  const numberFormat = (value) => {
  const absValue = Math.abs(value || 0);

  const formattedValue = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(absValue);

  return value < 0
    ? `(₹${formattedValue})`
    : `₹${formattedValue}`;
};

  function handlePreview() {
    if (props.data) {
      props.data.splice(dataInd, 1);
    }
    history.push("/PreviewPage");
    localStorage.setItem("currentClassificationName", props.name);
    dispatch({ type: actionTypes.SET_CLASSIFICATION, payload: props.data });
    dispatch({ type: actionTypes.SET_CLASSIFICATIONNAME, payload: props.name });
  }

  return (
    <motion.div
      className={fscss.previewCard}
      onClick={() => {
        handlePreview();
      }}
      whileHover={{
        scale: 1.02,
        // transition: { duration: 0.1 },
      }}
    >
      <div className={`${commoncss.labelBlack} ${commoncss.fs18} ${commoncss.fw500} mb-4`}>{props.name}</div>
      <div className={commoncss.dFlex} style={{"gap":"20px"}}>
        <div className={commoncss.dFlexClm}>
          <span className={fscss.labelc1}>Current Year</span>
          <span className={`${commoncss.labelBlack} ${commoncss.fs14} ${commoncss.fw600}`}>{numberFormat(cy)}</span>
        </div>
        <div className={commoncss.dFlexClm}>
          <span className={fscss.labelc1}>Previous Year</span>
          <span className={`${commoncss.labelBlack} ${commoncss.fs14} ${commoncss.fw600}`}>{numberFormat(py)}</span>
        </div>
      </div>
      <div style={block} hidden>
        <div style={amount}>
          <p style={paraAmount}>
            Current Year:
            <span style={actualAmount}>
              {/* {
              props.name === "Income" ||
              props.name === "Equity" ||
              props.name === "Non Current Liabilities" ||
              props.name === "Current Liabilities"
                ? cy  ? numberFormat(cy * -1) : numberFormat(0)
                : numberFormat(cy)} */}
              {numberFormat(cy)}
            </span>
          </p>
        </div>
        <div style={amount}>
          <p style={paraAmount}>
            Previous Year:
            <span style={actualAmount}>
              {/* {
              props.name === "Income" ||
              props.name === "Equity" ||
              props.name === "Non Current Liabilities" ||
              props.name === "Current Liabilities"
                ? py ? numberFormat(py * -1) : numberFormat(0)
                : numberFormat(py)}
              } */}
              {numberFormat(py)}
            </span>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default PreviewCard;
